/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getOrder = /* GraphQL */ `query GetOrder {
  getOrder {
    orderId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetOrderQueryVariables, APITypes.GetOrderQuery>;
export const getRequestToPay = /* GraphQL */ `query GetRequestToPay($id: ID!) {
  getRequestToPay(id: $id) {
    id
    orderID
    expirationTime
    createdAt
    saleID
    creator
    customerID
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRequestToPayQueryVariables,
  APITypes.GetRequestToPayQuery
>;
export const listRequestToPays = /* GraphQL */ `query ListRequestToPays(
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  listRequestToPays(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRequestToPaysQueryVariables,
  APITypes.ListRequestToPaysQuery
>;
export const requestToPayByOrderID = /* GraphQL */ `query RequestToPayByOrderID(
  $orderID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  requestToPayByOrderID(
    orderID: $orderID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestToPayByOrderIDQueryVariables,
  APITypes.RequestToPayByOrderIDQuery
>;
export const requestToPayBySaleID = /* GraphQL */ `query RequestToPayBySaleID(
  $saleID: ID!
  $expirationTime: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  requestToPayBySaleID(
    saleID: $saleID
    expirationTime: $expirationTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestToPayBySaleIDQueryVariables,
  APITypes.RequestToPayBySaleIDQuery
>;
export const requestToPayBySaleIDAndCreatedAt = /* GraphQL */ `query RequestToPayBySaleIDAndCreatedAt(
  $saleID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  requestToPayBySaleIDAndCreatedAt(
    saleID: $saleID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestToPayBySaleIDAndCreatedAtQueryVariables,
  APITypes.RequestToPayBySaleIDAndCreatedAtQuery
>;
export const requestToPayByCreator = /* GraphQL */ `query RequestToPayByCreator(
  $creator: ID!
  $expirationTime: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  requestToPayByCreator(
    creator: $creator
    expirationTime: $expirationTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestToPayByCreatorQueryVariables,
  APITypes.RequestToPayByCreatorQuery
>;
export const requestToPayByCustomerID = /* GraphQL */ `query RequestToPayByCustomerID(
  $customerID: ID!
  $expirationTime: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRequestToPayFilterInput
  $limit: Int
  $nextToken: String
) {
  requestToPayByCustomerID(
    customerID: $customerID
    expirationTime: $expirationTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderID
      expirationTime
      createdAt
      saleID
      creator
      customerID
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestToPayByCustomerIDQueryVariables,
  APITypes.RequestToPayByCustomerIDQuery
>;
export const getSale = /* GraphQL */ `query GetSale($id: ID!) {
  getSale(id: $id) {
    id
    username
    firstname
    lastname
    branch
    baskets {
      nextToken
      __typename
    }
    customers {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSaleQueryVariables, APITypes.GetSaleQuery>;
export const listSales = /* GraphQL */ `query ListSales(
  $filter: ModelSaleFilterInput
  $limit: Int
  $nextToken: String
) {
  listSales(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListSalesQueryVariables, APITypes.ListSalesQuery>;
export const getBasket = /* GraphQL */ `query GetBasket($id: ID!) {
  getBasket(id: $id) {
    id
    basketID
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBasketQueryVariables, APITypes.GetBasketQuery>;
export const listBaskets = /* GraphQL */ `query ListBaskets(
  $filter: ModelBasketFilterInput
  $limit: Int
  $nextToken: String
) {
  listBaskets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      basketID
      saleID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBasketsQueryVariables,
  APITypes.ListBasketsQuery
>;
export const getAddress = /* GraphQL */ `query GetAddress($id: ID!) {
  getAddress(id: $id) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAddressQueryVariables,
  APITypes.GetAddressQuery
>;
export const listAddresses = /* GraphQL */ `query ListAddresses(
  $filter: ModelAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  listAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      customerID
      address
      district
      email
      firstname
      lastname
      name
      phone
      postcode
      subDistrict
      province
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAddressesQueryVariables,
  APITypes.ListAddressesQuery
>;
export const getTaxInvoiceAddress = /* GraphQL */ `query GetTaxInvoiceAddress($id: ID!) {
  getTaxInvoiceAddress(id: $id) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    companyName
    companyBranch
    taxID
    isDefault
    requestTaxInvoice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaxInvoiceAddressQueryVariables,
  APITypes.GetTaxInvoiceAddressQuery
>;
export const listTaxInvoiceAddresses = /* GraphQL */ `query ListTaxInvoiceAddresses(
  $filter: ModelTaxInvoiceAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  listTaxInvoiceAddresses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      customerID
      address
      district
      email
      firstname
      lastname
      name
      phone
      postcode
      subDistrict
      province
      companyName
      companyBranch
      taxID
      isDefault
      requestTaxInvoice
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaxInvoiceAddressesQueryVariables,
  APITypes.ListTaxInvoiceAddressesQuery
>;
export const getCustomer = /* GraphQL */ `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    customerID
    email
    firstname
    lastname
    address {
      nextToken
      __typename
    }
    taxInvoice {
      nextToken
      __typename
    }
    phone_number
    basketID
    sales {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerQueryVariables,
  APITypes.GetCustomerQuery
>;
export const listCustomers = /* GraphQL */ `query ListCustomers(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomersQueryVariables,
  APITypes.ListCustomersQuery
>;
export const customerByCustomerID = /* GraphQL */ `query CustomerByCustomerID(
  $customerID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByCustomerID(
    customerID: $customerID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByCustomerIDQueryVariables,
  APITypes.CustomerByCustomerIDQuery
>;
export const customerByEmail = /* GraphQL */ `query CustomerByEmail(
  $email: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByEmailQueryVariables,
  APITypes.CustomerByEmailQuery
>;
export const customerByPhone = /* GraphQL */ `query CustomerByPhone(
  $phone_number: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customerByPhone(
    phone_number: $phone_number
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerByPhoneQueryVariables,
  APITypes.CustomerByPhoneQuery
>;
export const getDraftOrder = /* GraphQL */ `query GetDraftOrder($id: ID!) {
  getDraftOrder(id: $id) {
    id
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDraftOrderQueryVariables,
  APITypes.GetDraftOrderQuery
>;
export const listDraftOrders = /* GraphQL */ `query ListDraftOrders(
  $filter: ModelDraftOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listDraftOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      data
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDraftOrdersQueryVariables,
  APITypes.ListDraftOrdersQuery
>;
export const getSaleStat = /* GraphQL */ `query GetSaleStat(
  $id: ID!
  $granularity: Granularity!
  $timestamp: AWSTimestamp!
) {
  getSaleStat(id: $id, granularity: $granularity, timestamp: $timestamp) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    totalCustomer
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSaleStatQueryVariables,
  APITypes.GetSaleStatQuery
>;
export const listSaleStats = /* GraphQL */ `query ListSaleStats(
  $id: ID
  $granularityTimestamp: ModelSaleStatPrimaryCompositeKeyConditionInput
  $filter: ModelSaleStatFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSaleStats(
    id: $id
    granularityTimestamp: $granularityTimestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      totalCustomer
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSaleStatsQueryVariables,
  APITypes.ListSaleStatsQuery
>;
export const saleStatByGranularityAndTimestamp = /* GraphQL */ `query SaleStatByGranularityAndTimestamp(
  $id: ID!
  $granularityTimestamp: ModelSaleStatByIDWithGranularityCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSaleStatFilterInput
  $limit: Int
  $nextToken: String
) {
  saleStatByGranularityAndTimestamp(
    id: $id
    granularityTimestamp: $granularityTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      totalCustomer
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SaleStatByGranularityAndTimestampQueryVariables,
  APITypes.SaleStatByGranularityAndTimestampQuery
>;
export const saleStatByGranularityWithTimestamp = /* GraphQL */ `query SaleStatByGranularityWithTimestamp(
  $granularity: Granularity!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSaleStatFilterInput
  $limit: Int
  $nextToken: String
) {
  saleStatByGranularityWithTimestamp(
    granularity: $granularity
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      totalCustomer
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SaleStatByGranularityWithTimestampQueryVariables,
  APITypes.SaleStatByGranularityWithTimestampQuery
>;
export const getSaleCustomerStat = /* GraphQL */ `query GetSaleCustomerStat(
  $id: ID!
  $granularity: Granularity!
  $timestamp: AWSTimestamp!
) {
  getSaleCustomerStat(
    id: $id
    granularity: $granularity
    timestamp: $timestamp
  ) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSaleCustomerStatQueryVariables,
  APITypes.GetSaleCustomerStatQuery
>;
export const listSaleCustomerStats = /* GraphQL */ `query ListSaleCustomerStats(
  $id: ID
  $granularityTimestamp: ModelSaleCustomerStatPrimaryCompositeKeyConditionInput
  $filter: ModelSaleCustomerStatFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSaleCustomerStats(
    id: $id
    granularityTimestamp: $granularityTimestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      saleID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSaleCustomerStatsQueryVariables,
  APITypes.ListSaleCustomerStatsQuery
>;
export const saleCustomerStatByGranularityAndTimestamp = /* GraphQL */ `query SaleCustomerStatByGranularityAndTimestamp(
  $id: ID!
  $granularityTimestamp: ModelSaleCustomerStatByIDWithGranularityCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSaleCustomerStatFilterInput
  $limit: Int
  $nextToken: String
) {
  saleCustomerStatByGranularityAndTimestamp(
    id: $id
    granularityTimestamp: $granularityTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      saleID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SaleCustomerStatByGranularityAndTimestampQueryVariables,
  APITypes.SaleCustomerStatByGranularityAndTimestampQuery
>;
export const saleCustomerStatByGranularityWithTimestamp = /* GraphQL */ `query SaleCustomerStatByGranularityWithTimestamp(
  $granularity: Granularity!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSaleCustomerStatFilterInput
  $limit: Int
  $nextToken: String
) {
  saleCustomerStatByGranularityWithTimestamp(
    granularity: $granularity
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      saleID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SaleCustomerStatByGranularityWithTimestampQueryVariables,
  APITypes.SaleCustomerStatByGranularityWithTimestampQuery
>;
export const saleCustomerStatBySaleIDAndGranularityAndTimestamp = /* GraphQL */ `query SaleCustomerStatBySaleIDAndGranularityAndTimestamp(
  $saleID: ID!
  $granularityTimestamp: ModelSaleCustomerStatBySaleIDWithGranularityAndTimestampCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSaleCustomerStatFilterInput
  $limit: Int
  $nextToken: String
) {
  saleCustomerStatBySaleIDAndGranularityAndTimestamp(
    saleID: $saleID
    granularityTimestamp: $granularityTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      saleID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SaleCustomerStatBySaleIDAndGranularityAndTimestampQueryVariables,
  APITypes.SaleCustomerStatBySaleIDAndGranularityAndTimestampQuery
>;
export const getCustomerStat = /* GraphQL */ `query GetCustomerStat(
  $id: ID!
  $granularity: Granularity!
  $timestamp: AWSTimestamp!
) {
  getCustomerStat(id: $id, granularity: $granularity, timestamp: $timestamp) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCustomerStatQueryVariables,
  APITypes.GetCustomerStatQuery
>;
export const listCustomerStats = /* GraphQL */ `query ListCustomerStats(
  $id: ID
  $granularityTimestamp: ModelCustomerStatPrimaryCompositeKeyConditionInput
  $filter: ModelCustomerStatFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCustomerStats(
    id: $id
    granularityTimestamp: $granularityTimestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCustomerStatsQueryVariables,
  APITypes.ListCustomerStatsQuery
>;
export const customerStatByGranularityAndTimestamp = /* GraphQL */ `query CustomerStatByGranularityAndTimestamp(
  $id: ID!
  $granularityTimestamp: ModelCustomerStatByIDWithGranularityCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerStatFilterInput
  $limit: Int
  $nextToken: String
) {
  customerStatByGranularityAndTimestamp(
    id: $id
    granularityTimestamp: $granularityTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerStatByGranularityAndTimestampQueryVariables,
  APITypes.CustomerStatByGranularityAndTimestampQuery
>;
export const customerStatByGranularityWithTimestamp = /* GraphQL */ `query CustomerStatByGranularityWithTimestamp(
  $granularity: Granularity!
  $timestamp: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCustomerStatFilterInput
  $limit: Int
  $nextToken: String
) {
  customerStatByGranularityWithTimestamp(
    granularity: $granularity
    timestamp: $timestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      timestamp
      granularity
      totalSaleVolume
      totalOrder
      productList
      orderList
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomerStatByGranularityWithTimestampQueryVariables,
  APITypes.CustomerStatByGranularityWithTimestampQuery
>;
export const getOrderID = /* GraphQL */ `query GetOrderID($key: ID!) {
  getOrderID(key: $key) {
    key
    counter
    lastEdited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderIDQueryVariables,
  APITypes.GetOrderIDQuery
>;
export const listOrderIDS = /* GraphQL */ `query ListOrderIDS(
  $key: ID
  $filter: ModelOrderIDFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listOrderIDS(
    key: $key
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      key
      counter
      lastEdited
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderIDSQueryVariables,
  APITypes.ListOrderIDSQuery
>;
export const getSaleCustomers = /* GraphQL */ `query GetSaleCustomers($id: ID!) {
  getSaleCustomers(id: $id) {
    id
    saleID
    customerID
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSaleCustomersQueryVariables,
  APITypes.GetSaleCustomersQuery
>;
export const listSaleCustomers = /* GraphQL */ `query ListSaleCustomers(
  $filter: ModelSaleCustomersFilterInput
  $limit: Int
  $nextToken: String
) {
  listSaleCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      saleID
      customerID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSaleCustomersQueryVariables,
  APITypes.ListSaleCustomersQuery
>;
